import React from 'react';
import { useAppDispatch } from 'app/store';
import {
  deleteUnusedInvitation,
  reactivateUnusedInvitation,
} from 'features/invitationLinksList/invitationLinksListActions';
import { toast } from 'react-toastify';

interface InvitationLinksActionsListProps {
  invitationId: number;
  invitationLink: string;
}

const InvitationLinksActionsList: React.FC<InvitationLinksActionsListProps> = ({
  invitationId,
  invitationLink
}) => {
  const dispatch = useAppDispatch();

  const handleCopylink = () => {
    navigator.clipboard.writeText(invitationLink)
      .then(() => {
        toast.success("Invitation link copied!");
      })
      .catch((err) => {
        console.error("Error copying the link:", err);
      });
  };
  const handleReactivate = () => {
    dispatch(reactivateUnusedInvitation(invitationId));
  };
  const handleDelete = () => {
    dispatch(deleteUnusedInvitation(invitationId));
  };

  return (
    <>
      <li>
        <button onClick={handleCopylink} aria-label="Copy invitation link">
          Copy invitation link
        </button>
      </li>
      <li>
        <button onClick={handleReactivate} aria-label="Resend invitation">
          Resend invitation
        </button>
      </li>
      <li>
        <button onClick={handleDelete} aria-label="Delete invitation">
          Delete invitation
        </button>
      </li>
    </>
  );
};

export default InvitationLinksActionsList;
